import React from 'react';
import { TabGridContianer } from './physicianDetailTab.styled';
import PhysicianDetailTabList from './physicianDetailTab';

const PhysicianDetailTabListContainer = ({
    accountDetailTabList,
    tabActiveId,
    tabSwitch,
}) => {
    return (
        <>
            <TabGridContianer>
                {accountDetailTabList.map((accountTab) => {
                    return (
                        <PhysicianDetailTabList
                            key={accountTab.id}
                            label={accountTab.label}
                            id={accountTab.id}
                            isTabActive={tabActiveId === accountTab.id}
                            tabSwitch={tabSwitch}
                        />
                    );
                })}
            </TabGridContianer>
        </>
    );
};

export default PhysicianDetailTabListContainer;
